import { Stack } from "@mui/material";
import { Tarjeta, TituloTarjeta } from "../kit/Tarjeta";
import Etiqueta from "../kit/Etiqueta";
import EstadoChip from "../kit/EstadoChip";
import { GuiaCoguia } from "./TemaLista";
import { TemaApp } from "../../types/tema";
import { categoriaDe, tiposDeTema } from "../../utils/categoria";
import { chipDeTema, temaRevocadoParaMi } from "../../utils/estados";
import { useIr } from "../../utils/enlaces";

/**
 * Tema de la persona como tarjeta destacada: se usa cuando tiene un único tema
 * (p. ej. el tema de tesis del estudiante). Mismo orden que el catálogo:
 * título, luego etiquetas (estado, categoría, tipos) y luego guía/coguía.
 */
export default function TemaTarjeta({ tema }: { tema: TemaApp }) {
  const ir = useIr();
  const tipos = tiposDeTema(tema);
  const chip = chipDeTema(tema);
  // Un tema que le revocaron ya no es suyo ni puede volver a tomarlo: queda a la
  // vista, con su chip, pero apagado.
  const revocado = temaRevocadoParaMi(tema);

  return (
    <Tarjeta
      deshabilitada={revocado}
      onClick={(e) => ir(e, `/app/temas/${tema.id}`)}
    >
      <TituloTarjeta>{tema.titulo}</TituloTarjeta>

      <Stack direction="row" flexWrap="wrap" alignItems="center" gap={0.6}>
        <EstadoChip label={chip.label} tono={chip.tono} icono={chip.icono} denso />
        <Etiqueta>{categoriaDe(tema)}</Etiqueta>
        {tipos.map((tipo) => (
          <Etiqueta key={tipo} variante="contorno">
            {tipo}
          </Etiqueta>
        ))}
      </Stack>

      <GuiaCoguia tema={tema} />
    </Tarjeta>
  );
}
